var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const CONFIGURA_ATTRIBUTE = "C0nf1gura";
const CONFIGURA_SHEBANG = "arug1fn0C";
// Support function. Did not manage to check both attribute and value in one step
const hasConfiguraAttribute = (data) => {
    return typeof data === "object" && data !== null;
};
/**
 * Base class for classes handling input and output in globally shared environments.
 */
export class CfgIOManager {
    constructor() {
        this._warningSuppliers = [];
        // A lock to avoid circular write. Asynchronous conditions can make this not be enough.
        // Avoid creating pre-conditions where this can happen.
        this._receiveInProgress = false;
        this._messageListeners = [];
        this._getIndexOfMessageListener = (l) => this._messageListeners.findIndex((item) => l === item.l);
    }
    addWarningSupplier(supplier) {
        this._warningSuppliers.push(supplier);
    }
    removeWarningSupplier(supplier) {
        const i = this._warningSuppliers.indexOf(supplier);
        if (i === -1) {
            return;
        }
        this._warningSuppliers.splice(i, 1);
    }
    getWarnings() {
        return this._warningSuppliers.reduce((aggregated, supplier) => {
            for (const warning of supplier.getWarnings()) {
                aggregated.push(warning);
            }
            return aggregated;
        }, []);
    }
    /**
     * Listen for the message messageKey being received.
     */
    listenForMessage(l, messageKey) {
        if (this._getIndexOfMessageListener(l) !== -1) {
            console.warn("Tried to add listener twice");
            return false;
        }
        this._messageListeners.push({ l, messageKey });
        return true;
    }
    /**
     * Removes the listener
     */
    stopListenForMessage(l) {
        const i = this._getIndexOfMessageListener(l);
        if (i === -1) {
            console.warn("Tried to stopListen on unknown listener");
            return false;
        }
        this._messageListeners.splice(i, 1);
        return true;
    }
    get receiveInProgress() {
        return this._receiveInProgress;
    }
    get hasMessageListeners() {
        return 0 < this._messageListeners.length;
    }
    _containerListener(data) {
        if (CfgIOManager._inhibitAllReceive) {
            return;
        }
        if (!CfgIOManager.isIOContainer(data)) {
            return;
        }
        CfgIOManager._inhibitAllReceive = true;
        this._receiveInProgress = true;
        // The 15 or so rows below is one of the cases where I believe building a clever
        // data structure of so would probably be worse for performance than just looping
        // as the subscribers are expected to be very few
        const listeners = this._messageListeners;
        const allMessageKeys = listeners.reduce((a, c) => {
            a.add(c.messageKey);
            return a;
        }, new Set());
        const promises = [];
        (() => __awaiter(this, void 0, void 0, function* () {
            for (const messageKey of allMessageKeys) {
                if (!CfgIOManager.hasIOContainerMessageKey(data, messageKey)) {
                    continue;
                }
                const message = CfgIOManager.getMessageFromIOContainer(data, messageKey);
                for (const item of listeners) {
                    if (item.messageKey !== messageKey) {
                        continue;
                    }
                    // async, not waiting on each other. Might need to change.
                    promises.push(item.l(message));
                }
            }
        }))();
        Promise.all(promises)
            .then(() => {
            this._receiveInProgress = false;
            CfgIOManager._inhibitAllReceive = false;
        })
            .catch(() => {
            this._receiveInProgress = false;
            CfgIOManager._inhibitAllReceive = false;
        });
    }
}
CfgIOManager.isIOContainer = (data) => hasConfiguraAttribute(data) && data[CONFIGURA_ATTRIBUTE] === CONFIGURA_SHEBANG;
CfgIOManager.hasIOContainerMessageKey = (container, messageKey) => messageKey in container.messages;
CfgIOManager.getMessageFromIOContainer = (container, messageKey) => {
    if (!CfgIOManager.isIOContainer(container)) {
        throw new Error("The passed data was not a CfgIOContainer. It is to be expected that such data messages can arrive, so please use isIOContainer function to filter them out before calling this.");
    }
    if (!CfgIOManager.hasIOContainerMessageKey(container, messageKey)) {
        throw new Error(`The passed data did not have the messageKey "${messageKey}". You can test for this using hasIOContainerMessageKey function.`);
    }
    return container.messages[messageKey];
};
CfgIOManager.makeContainer = (messages) => ({
    [CONFIGURA_ATTRIBUTE]: CONFIGURA_SHEBANG,
    messages,
});
CfgIOManager._inhibitAllReceive = false;
